import React from 'react'
import './components.css'
import Youtubeembed from './Youtubeembed'

const Youtubeslider = ({ videos }) => {

    // console.log(videos)

    return (
        <div>
            <div className='flex-container flex-row gap-2'>
                {
                    videos.map(vid => (
                        <div className='card min-w-[300px]'>
                            <Youtubeembed videourl={vid.video} />
                        </div>
                    ))
                }
            </div>
        </div >
    )
}

export default Youtubeslider